import {
  createContext,
  useContext,
  type Dispatch,
  type SetStateAction,
} from "react";

import type {
  FmMapRadarDescriptor,
  FmMapRadarFrameDescriptor,
} from "./FmMapWorkspaceRoot.types";

export type FmMapRadarCopy = FmMapRadarDescriptor["copy"];

export interface FmMapRadarPlaybackModel {
  activeFrame: FmMapRadarFrameDescriptor | null;
  activeIndex: number;
  canStep: boolean;
  copy: FmMapRadarCopy;
  enabled: boolean;
  error: string | null;
  frameCount: number;
  layerStatus: string | null;
  loading: boolean;
  noData: boolean;
  opacity: number;
  playing: boolean;
  propertyId: string | null;
  reload: () => void;
  setOpacity: (value: number) => void;
  setPlaying: Dispatch<SetStateAction<boolean>>;
  statusText: string;
  windowEnd: string | null;
  windowStart: string | null;
  stepBackward: () => void;
  stepForward: () => void;
}

export const FmMapObservationContext =
  createContext<FmMapRadarPlaybackModel | null>(null);

export function useFmMapObservation(): FmMapRadarPlaybackModel {
  const value = useContext(FmMapObservationContext);
  if (!value) {
    throw new Error(
      "FmMap observation controls require FmMapObservationProvider.",
    );
  }
  return value;
}
